import { render, staticRenderFns } from "./agents-table.vue?vue&type=template&id=7f64fddf"
import script from "./agents-table.vue?vue&type=script&lang=js"
export * from "./agents-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports